import { normalizeError, normalizeNestedErrors } from "./logger";
import type { LogLevel, LogRecord, Logger } from "./logger";

/** One JSON line per record, in the shape the Datadog drains expect. */
export const writeJsonToConsole = ({
  level,
  message,
  error,
  meta,
}: LogRecord): void => {
  const normalized = normalizeError(error);
  console[level](
    JSON.stringify({
      ...meta,
      level,
      message,
      ...(normalized ? { error: normalized } : {}),
    })
  );
};

export const formatLogMessage = (params: unknown[]): string => {
  return params
    .map((param, i) => {
      if (param instanceof Error) {
        return `${param.name}: ${param.message}\n${param.stack}`;
      }
      if (typeof param === "object") {
        return (
          (i == 0 && params.length === 1 ? "msg: " : "") +
          JSON.stringify(param, normalizeNestedErrors, 2)
        );
      }
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      return String(param);
    })
    .join(" ");
};

// Keeps the console's message text as it was, so existing log queries still match.
export const replaceConsoleWithLogger = (logger: Logger) => {
  const bridge =
    (log: Logger[LogLevel]) =>
    (...params: unknown[]) =>
      log(formatLogMessage(params));
  global.console.log = bridge(logger.info);
  global.console.error = bridge(logger.error);
  global.console.warn = bridge(logger.warn);
  global.console.info = bridge(logger.info);
  global.console.debug = bridge(logger.debug);
};
